module.exports = __webpack_public_path__ + "img/school4.b57e73cc.jpg";